import { render, staticRenderFns } from "./receivable_details.vue?vue&type=template&id=b0779a7a&"
import script from "./receivable_details.vue?vue&type=script&lang=js&"
export * from "./receivable_details.vue?vue&type=script&lang=js&"
import style0 from "./receivable_details.vue?vue&type=style&index=0&id=b0779a7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports